<div class="container-fluid">
  <p [hidden]="!loading">
    <wl-busy [show]="loading"></wl-busy>
    {{ 'common.loading' | translate | titlecase }}...
  </p>

  <div class="alert alert-danger" [hidden]="!loadError">
    {{ loadError }}
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-6">
          <div class="highlight-box">
            <h3>{{ 'event.dashboard.component.status' | translate | titlecase }}</h3>
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <label class="control-label col-sm-6">
                    <strong>{{ 'event.dashboard.component.status' | translate | titlecase }}</strong>
                  </label>
                  <div class="col-sm-6">
                    <p *ngIf="isFutureEvent">{{ 'event.dashboard.component.future-event' | translate | titlecase }}</p>
                    <p *ngIf="isRegistrationOpen">{{ 'event.dashboard.component.registration-open' | translate | titlecase }}</p>
                    <p *ngIf="isUnderway">{{ 'event.dashboard.component.underway' | translate | titlecase }}</p>
                    <p *ngIf="isPastEvent">{{ 'event.dashboard.component.past-event' | translate | titlecase }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <label class="control-label col-sm-6">
                    <strong>{{ 'event.dashboard.component.attendees' | translate | titlecase }}</strong>
                  </label>
                  <div class="col-sm-6">
                    {{ event.PotentialAttendees }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <label class="control-label col-sm-6">
                    <strong>{{ 'event.dashboard.component.time-to-event' | translate | titlecase }}</strong>
                  </label>
                  <div class="col-sm-6">
                    {{ event.StartDate | date | wlDayDifferenceCount }} {{ 'event.dashboard.component.days' | translate }}
                    <p *ngIf="isPastEvent">{{ 'event.dashboard.component.ago' | translate }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <label class="control-label col-sm-6">
                    <strong>{{ 'event.dashboard.component.max-attendees' | translate | titlecase }}</strong>
                  </label>
                  <div class="col-sm-6">
                    {{ event.MaxAttendees }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row" [hidden]="!event.MinAttendees">
              <div class="col-md-6 col-md-offset-6">
                <div class="row">
                  <label class="control-label col-sm-6">
                    <strong>{{ 'event.dashboard.component.minimum-needed' | translate | titlecase }}</strong>
                  </label>
                  <div class="col-sm-6">
                    {{ event.MinAttendees }} {{ 'event.dashboard.component.by' | translate }} {{ event.MinAttendeesActionDate | date }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p class="wc-event-dashboard-report-buttons">
            <button
              pButton
              type="button"
              (click)="viewEventReport()"
              class="btn btn-default"
              icon="pi pi-file-pdf"
              [label]="'event.dashboard.component.view-event-report' | translate | titlecase"
            ></button>
            <button
              pButton
              type="button"
              (click)="printNameBadges()"
              class="btn btn-default"
              icon="pi pi-print"
              [label]="'event.dashboard.component.print-name-badges' | translate | titlecase"
            ></button>
          </p>
        </div>

        <div class="highlight-box col-sm-6">
          <h3>{{ 'event.dashboard.component.goal-tracking' | translate | titlecase }}</h3>
          <div class="row">
            <div class="col-sm-12">
              <label>
                <strong>{{ 'event.dashboard.component.attendees' | translate | titlecase }}</strong>
              </label>
              <img
                src="/assets/img/help.png"
                [title]="'event.dashboard.component.goal-tracking-attendees-help' | translate"
                class="wc-help-icon"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              {{ event.PotentialAttendees }} {{ 'event.dashboard.component.of' | translate }} {{ event.AttendeeGoal }} ({{
                'event.dashboard.component.max-of' | translate
              }}
              {{ event.MaxAttendees }})
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  [style.width]="(event.AttendeeGoal > 0 ? (event.AttendingAttendees * 100) / event.AttendeeGoal : 0) + '%'"
                ></div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <label>
                <strong>{{ 'event.dashboard.component.revenue' | translate | titlecase }}</strong>
              </label>
              <img
                src="/assets/img/help.png"
                [title]="'event.dashboard.component.goal-tracking-revenue-help' | translate"
                class="wc-help-icon"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              {{ amountInvoiced | currency }} {{ 'event.dashboard.component.of' | translate }} {{ event.SalesGoal | currency }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  [style.width]="(event.SalesGoal > 0 ? (amountInvoiced * 100) / event.SalesGoal : 0) + '%'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <h3>{{ 'event.dashboard.component.event-items' | translate }}</h3>

      <div class="wc-full-card-with-prime-list" [hidden]="loading">
        <p-dataView #eventItemDataGrid [value]="eventItems">
          <ng-template pTemplate="list" let-items>
            <div class="highlight-box" *ngFor="let eventItemSummary of items">
              <div class="wc-event-dashboard-controls pull-right">
                <a href="#" (click)="$event.preventDefault(); goToRegistrationManagement(eventItemSummary.EventItemId)">
                  <span class="pi pi-search" [title]="'event.dashboard.component.view-event-item-registrations-tooltip' | translate"></span>
                </a>
              </div>
              <p class="wc-event-item-name">
                <strong>{{ eventItemSummary.Descr }}</strong>
                ({{ eventItemSummary.NonMemberPrice | currency }}, {{ eventItemSummary.MemberPrice | currency }}
                {{ 'event.dashboard.component.member' | translate | titlecase }})
              </p>
              <table class="wc-event-item-detail">
                <tr>
                  <td>{{ 'event.dashboard.component.number-sold' | translate | titlecase }}: {{ eventItemSummary.Sold }}</td>
                  <td>
                    {{ 'event.dashboard.component.amount-invoiced' | translate | titlecase }}:
                    {{ eventItemSummary.AmountInvoiced | currency }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ 'event.dashboard.component.attendee-count' | translate | titlecase }}: {{ eventItemSummary.PotentialAttendees }}
                  </td>
                  <td>
                    {{ 'event.dashboard.component.amount-paid' | translate | titlecase }}: {{ eventItemSummary.AmountPaid | currency }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ 'event.dashboard.component.attendee-name-unknown-count' | translate | titlecase }}:
                    {{ eventItemSummary.AttendeeNameUnknownCount }}
                  </td>
                  <td></td>
                </tr>
              </table>
            </div>
          </ng-template>
        </p-dataView>
      </div>
    </div>
  </div>

  <app-back-to-top></app-back-to-top>
</div>
